import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements OnInit {
  @Input() videoList;
  @Input() trayImageAttachment;


  public config = {
    autoplay: true,
    autoHide: true,
    autoHideTime: 3000,
    sources: [
      // Demo videó
      { title: 'Pale Blue Dot', src: 'http://static.videogular.com/assets/videos/videogular.mp4', type: 'video/mp4' },
      { title: 'Big Buck Bunny', src: 'http://static.videogular.com/assets/videos/big_buck_bunny_720p_h264.mov', type: 'video/mp4' },
      { title: 'Elephants Dream', src: 'http://static.videogular.com/assets/videos/elephants-dream.mp4', type: 'video/mp4' }
    ]
  };

  private currentVideoIndex = 0;
  private currentVideoItem = this.config.sources[this.currentVideoIndex];
  private videoApi;


  constructor() { }

  ngOnInit() {
  }

  onPlayerReady(api) {
    this.videoApi = api;

    this.videoApi.getDefaultMedia().subscriptions.loadedMetadata.subscribe(this.playVideo.bind(this));
    this.videoApi.getDefaultMedia().subscriptions.ended.subscribe(this.nextVideo.bind(this));
  }

  nextVideo() {
    this.currentVideoIndex++;

    if (this.currentVideoIndex === this.config.sources.length) {
      this.currentVideoIndex = 0;
    }

    this.currentVideoItem = this.config.sources[this.currentVideoIndex];
  }

  playVideo() {
    this.videoApi.play();
  }
}
